import { ConfigProvider, Segmented } from "antd";
import { CalendarOutlined } from "@ant-design/icons";

interface PeriodFilterPropsI {
  options: { value: string; label: string }[];
  value: string;
  onChange: (value: string) => void;
}

export const PeriodFilter = ({
  options,
  value,
  onChange,
}: PeriodFilterPropsI) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      gap: 10,
      flexWrap: "wrap",
    }}
  >
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "4px 12px",
        borderRadius: 999,
        background: "#0B0D0B",
        color: "#fff",
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: "0.04em",
        textTransform: "uppercase",
        border: "1px solid rgba(37, 210, 40, 0.5)",
      }}
    >
      <CalendarOutlined style={{ color: "#25D228" }} />
      Periodo
    </span>
    <ConfigProvider
      theme={{
        components: {
          Segmented: {
            trackBg: "#eef0ee",
            itemColor: "#4b5563",
            itemHoverColor: "#0B0D0B",
            itemHoverBg: "rgba(11, 13, 11, 0.06)",
            itemSelectedBg: "#0B0D0B",
            itemSelectedColor: "#ffffff",
          },
        },
      }}
    >
      <Segmented
        value={value}
        onChange={(val) => onChange(val as string)}
        options={options.map((el) => ({ value: el.value, label: el.label }))}
        style={{
          background: "#fff",
          padding: 4,
          fontWeight: 600,
          boxShadow: "0 2px 10px rgba(11, 13, 11, 0.12)",
        }}
      />
    </ConfigProvider>
  </div>
);
